import { getStore } from 'core_main/store';
import { mapOffhoursDisplayToAvailability } from 'globals/mapOffhoursDisplayToAvailability';
import { DISABLED, ONLINE } from './constants';
import {
  createIsChatAvailableResponse,
  isInBusinessHours,
  isInHoliday,
} from './helpers';
import { IsChatAvailableResponse } from './types';

export const isChatAvailable = (): IsChatAvailableResponse => {
  const store = getStore();

  const { settings, schedule } = store;

  const { enabled, offhoursDisplay } = settings;

  if (!enabled) {
    return createIsChatAvailableResponse(DISABLED);
  }

  const isWithinHoliday = isInHoliday(schedule);

  const isWithinBusinessHours = isInBusinessHours(schedule);
  const isAvailable = isWithinBusinessHours && !isWithinHoliday;

  if (isAvailable || offhoursDisplay === ONLINE) {
    return createIsChatAvailableResponse(ONLINE);
  }

  return createIsChatAvailableResponse(
    mapOffhoursDisplayToAvailability(offhoursDisplay),
  );
};
